/**
 * 영역별 경로 — 사용자는 /app, 운영자는 /admin. 두 접두 밖은 전부 공개 화면이다
 * (260917-admin-area-split · 261013-account-brand-membership — 대행사 영역 /agency 는 없어졌다).
 *
 * ★ 두 영역에 같은 컴포넌트가 걸린 화면(비밀번호)의 링크는 이 표에서 꺼낸다. 공용 화면에 `/app/…` 리터럴을 쓰면
 *   운영자 화면에서도 컴파일되고, 운영자를 사용자 영역으로 보낸다(운영자 쿠키가 읽히지 않아 로그인 화면으로 튕긴다).
 */
import type { Role } from '@geo-admin/shared/contract/role.ts';
import type { Realm } from '@geo-admin/shared/contract/session.ts';

export const PATHS = {
  app: {
    home: '/app',
    brands: '/app/brands',
    brand: '/app/brands/$id',
    // query·sample 은 없다 — 질문 상세·샘플 상세는 운영자 영역에만 있다 (260921-client-report-chart-only)
    password: '/app/account/password',
    login: '/login',
  },
  admin: {
    home: '/admin',
    brands: '/admin/brands',
    agencies: '/admin/agencies',
    agency: '/admin/agencies/$id',
    brand: '/admin/brands/$id',
    query: '/admin/queries/$id',
    querySamples: '/admin/queries/$id/samples',
    sample: '/admin/samples/$id',
    password: '/admin/account/password',
    login: '/admin/login',
  },
} as const;

/** 세션이 영역별로 나뉜 뒤로는 서버가 "영역 ⇔ 역할"을 보장한다(1:1) — 화면은 역할로 영역을 고른다 */
export const realmOfRole = (role: Role | undefined): Realm => (role === 'admin' ? 'admin' : 'app');

export const pathsFor = (role: Role | undefined) => PATHS[realmOfRole(role)];

/** API 요청이 싣는 영역(어느 세션 쿠키를 읽을지). 공개 화면은 app 이다 — 로그인 쿠키는 서버가 역할로 고른다 */
export function realmOfPath(pathname: string): Realm {
  return pathname === '/admin' || pathname.startsWith('/admin/') ? 'admin' : 'app';
}
